import { makeStyles } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'

export const useStyles = makeStyles({
  root: {
    height: '100%'
  },
  content: {
    position: 'relative',
    marginBottom: 20,
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
    flexDirection: 'column',
    overflow: 'hidden'
  },
  rootMobile: {
    flexGrow: 1
  },
  appBar: {
    background: 'white',
    zIndex: 1200
  },
  sidebar: {
    '& > .MuiDrawer-paper': {
      background: '#7647B2',
      color: 'white'
    }
  },
  toolBar: {
    paddingLeft: 15,
    paddingRight: 5
  },
  menuSettings: {
    '& > .MuiMenu-paper': {
      background: '#7647B2',
      color: 'white'
    }
  },
  logo: {
    marginBottom: 15,
    flexGrow: 1
  },
  sidebarLogo: {
    height: 60,
    marginTop: 30,
    marginBottom: 30
  },
  component: {
    marginTop: 20
  },
  menuButton: {
    flexGrow: 0,
    color: 'gray'
  },
  settingsButton: {
    color: 'gray',
    flexGrow: 0,
    margin: 0
  },
  menuList: {
    width: 250
  },
  helpIcon: {
    color: theme.palette.common.lightOrange,
    position: 'relative',
    left: 12,
    bottom: 2,
    margin: 'auto'
  }
})
